/** Incident statuses that no longer count as open. */
export const CLOSED_INCIDENT = new Set(['resolved', 'closed', 'verified']);
/** Incident statuses where the platform is waiting on a human decision. */
export const NEEDS_DECISION = new Set([
  'awaiting_approval',
  'awaiting_review',
  'awaiting_action',
  'needs_approval',
  'needs_human',
  'needs_input',
]);
